<script>
import {computed, defineComponent, ref} from 'vue';
import {useRoute, useRouter} from 'vue-router';
import {useI18n} from "vue-i18n";
import tinycolor from "tinycolor2";
// import PaymentFormError from "@/javascript/views/paymentProcessors/PaymentFormError.vue";
export default defineComponent({
  name: 'CardOnly',
  // components: {PaymentFormError},
  props: {
    donationSessionStore: {
      type: Object,
      required: true
    },
    stylesStore: {
      type: Object,
      required: true
    },
    redirect: {
      type: Boolean,
      default: true
    },
    /** Override for button fill colors, hacking this for now, TODO refactor to use brand store **/
    buttonColor: {
      type: String,
      default: "#08602d"
    },
  },
  emits: ['payment-success'],

  setup(props, { emit }) {
    // Router
    const route = useRoute();
    const router = useRouter();
    const {t} = useI18n();

    const organizationId = computed(() => route.params.org);

    const stripeElements = ref();

    const getStripeClient = async () => {
      return await props.donationSessionStore.getStripeClient();
    };

    const initStripeForm = async () => {
      getStripeClient().then((loaded) => {
        if (!loaded) return;
        const stripe = props.donationSessionStore.stripeClient;

        let fonts = [{
            cssSrc: props.stylesStore.fontLink
          }];
        const appearance = {
          theme: 'stripe',
          variables: {
            fontFamily: `${props.stylesStore.fontList}`
          }
        };
        stripeElements.value = stripe?.elements({
            clientSecret: props.donationSessionStore.getClientSecret,
            loader: "always",
            paymentMethodCreation: "manual",
            appearance,
            fonts
          }
        );
        if (stripeElements.value) {
          const el = stripeElements.value.create(
            "payment",
            {
              layout: "accordion",
              defaultValues: {
                billingDetails: {
                  email: props.donationSessionStore.donationForm.donorEmail,
                  name: props.donationSessionStore.fullName
                }
              }
            });
          el.mount("#stripe-payment-form");
        }
      });
    };

    const submitDonation = async () => {
      const {error} = await stripeElements.value.submit();
      if (!error) {
        await props.donationSessionStore.submitPaymentForm(stripeElements.value);
        if (props.donationSessionStore.donationSession.completed) {
          if(props.redirect) {
            if(props.donationSessionStore.donationSession.redirectUrl){
              setTimeout(() => {
                const userSignedIn = props.donationSessionStore.donationSession.userAuthenticated;
                if (userSignedIn) {
                  const org = route.params.org || props.donationSessionStore.organizationId;
                  window.location.href = `/${org}/donor/dashboard/overview?donated=true`;
                } else {
                  window.location.href = props.donationSessionStore.donationSession.redirectUrl;
                }
              }, 4000);
            } else {
              setTimeout(() => {
                router.push({path: '/donate/thank_you'});
              }, 4000);
            }
          }else {
            emit('payment-success');
          }
        }
      }
    };

    return {
      t,
      organizationId,
      router,
      initStripeForm,
      submitDonation,
    };
  },

  computed: {
    formError() {
      return this.donationSessionStore.donationSession.errors?.error;
    },
    errorMessage() {
      return this.donationSessionStore.donationSession.errors?.message;
    },
    submitting() {
      return this.donationSessionStore.donationSession.submitting;
    },
    success() {
      return this.donationSessionStore.donationSession.completed;
    },
    tailwindButtonClasses(){
      let styles = "w-full py-2 px-4 rounded mt-20 ";
      if(this.stylesStore.classname !== ""){
        styles += `${this.stylesStore.classname}-button`;
      }else{
        styles += "active:animate-pulse text-default_white";
      }
      return styles;
    },
    successMessage() {
      return this.donationSessionStore.donationSession.successMessage;
    },
    // Hacking button colors for now
    cssProps(){
      let hov = tinycolor(this.buttonColor).darken(10).toHexString();
      return {
        '--button-color': this.buttonColor,
        '--button-hover': hov
      };
    },
  },

  mounted() {
    this.initStripeForm();
  }

});
</script>
<template>
  <div v-show="submitting">
    <div class=" flex items-center justify-center mt-50">
      <div
        class=" h-12 w-12 animate-spin rounded-full border-4 border-solid border-current border-e-transparent align-[-0.125em] text-surface motion-reduce:animate-[spin_1.5s_linear_infinite] dark:text-white"
        role="status"
      >
        <span class="sr-only font-fpc">Submitting Payment</span>
      </div>
    </div>
  </div>
  <div
    :style="cssProps"
  >
    <div
      v-show="!submitting && !success"
      id="stripe-payment-form"
      ref="paymentForm"
      class="font-fpc"
    />

    <div
      v-if="formError"
      class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mt-20"
      role="alert"
    >
      <strong class="font-bold mr-10">
        {{ t('payment.errors.error') }}
      </strong>
      <span class="block sm:inline">
        {{ t(errorMessage) }}
      </span>
    </div>

    <button
      v-show="!submitting && !success"
      ref="donateButton"
      :class="tailwindButtonClasses"
      @click="submitDonation"
    >
      Donate
    </button>
  </div>
  <div
    v-if="success"
    class="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mt-40"
    role="alert"
  >
    {{ successMessage }}
  </div>
</template>
<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');
button {
  background-color: var(--button-color) !important;
  &:hover {
    background-color: var(--button-hover) !important;
  }
}
.fpc-button{
  @apply bg-fpc_secondary hover:bg-fpc_secondary_dark text-default_black hover:text-default_white font-fpc
}
</style>
